import { MAIN_NOTIFICATION } from 'store/enums';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  mainNotification: { ...MAIN_NOTIFICATION },
  loader: true,
  streetType: null,
  documentType: null,
  loaderModal: false,
  loaderTextModal: null,
  maritalStatus: null,
  profession: null,
  sex: null,
  signType: null,
  townsCache: {},
  showRoomType: 'Cards',
  showRoomFilters: {
    perPage: 25,
    sortBy: null,
    sortDesc: true,
    currentPage: 1
  },
  operationsFilters: {
    perPage: 25,
    sortBy: 'updateDate',
    sortDesc: true,
    currentPage: 1
  },
  expirationsFilters: {
    perPage: 25,
    sortBy: 'expirationDate',
    sortDesc: true,
    currentPage: 1
  },
  commonFilters: {
    typeVehicle: 'TODOS',
    bodyStyle: null,
    rangePrice: ['<300', '>900'],
    filter: null,
    partner: null
  },
  paginationFilters: {
    campaigns: {
      perPage: 200,
      sortBy: null,
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    }
  },
  headersFields: [],
  sectionMenu: {},
  marks: [],
  models: [],
  bodyStyles: [],
  sectionMenuAction: {},
  tabsFields: [],
  apiBusy: false,
  imagesBenchFilter: {
    vehicleTypeOptions: [],
    vehicleLocationOptions: [],
    vehicleBrandOptions: [],
    vehicleModelOptions: [],
    vehicleVersionOptions: [],
    vehicleOptions: [],
    listIdVehicleOptions: []
  },
  tagsOptions: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
